import { useState, useEffect, useContext } from "react";

//Helpers
import isUserLoggedIn from "./helpers/redirect";
import { useNavigate } from "react-router-dom";
import StellaMode from "./tabs/settings/StellaMode";
import EditClinicalProfile from "./tabs/settings/EditClinicalProfile";
import Credits from "./tabs/settings/Credits";
import { useAuth } from "../../auth";
import { Breadcrumbs, Link, Tooltip, Typography } from "@mui/material";
import { HelpOutline, InfoOutlined, QrCode } from "@mui/icons-material";
import MerchantQr from "./clinicalNotesClinicalRoute/Components/MerchantQr";
import { getSubDomain, isAusDomain } from "./clinicalNotesClinicalRoute/lib/utils";
import PlansBilling from "./component/PlansBilling";
import { AppContext } from "../../context";

const ExpertClinicalSettingsDB = () => {
  const [selectedOption, setSelectedOption] = useState("Edit Profile");
  const [userData, setUserData] = useState({});
  const [openQrModal, setOpenQrModal] = useState(false);
  const [plans, setPlans] = useState([]);
  const { currentUser } = useAuth();
  const { expertDetails } = useContext(AppContext);
  const handleOption = (option) => {
    setSelectedOption(option);
  };
  const localView = new URLSearchParams(
    new URL(window.location.href).search
  ).get("view");

  const headers = {
    "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
    "Content-Type": "application/json",
  };

  const userID = JSON.parse(localStorage.getItem("profile"))?.UserId;
  const userEmail = JSON.parse(localStorage.getItem("profile"))?.Emailid;

  const navigate = useNavigate();



  // Check if user is logged in
  useEffect(() => {
    if (!currentUser) return

    setSelectedOption(localView == null ? "Edit Profile" : localView);
  }, []);

  console.log(localView);
  //Professionals
  useEffect(() => {
    postData();
  }, []);
  const postData = async () => {
    if (!currentUser) return
    const payload = {
      user_id: userID,
      email: userEmail,
      screen: null,
    };
    try {
      const response = await fetch(
        `https://us.uwc.world/new-uwc/professionals/get`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const postResponse = await response.json();
      setUserData(postResponse?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const fetchPlans = async () => {
    try {
      // Use context country data with fallback to localStorage
      const country = expertDetails?.profile?.country;
      let userId;
      
      // Try multiple sources for userId
      try {
        const profileData = JSON.parse(localStorage.getItem("profile"));
        userId = currentUser?.UserId || profileData?.UserId;
      } catch (e) {
        console.error("Error parsing profile data:", e);
        return;
      }

      if (!country || !userId) {
        console.error("Missing required data:", { 
          country, 
          userId, 
          expertDetailsLoaded: !!expertDetails?.profile,
          currentUserLoaded: !!currentUser?.UserId 
        });
        return;
      }

      const response = await fetch(
        `https://us.uwc.world//new-uwc/subscription/plans/list?country=${encodeURIComponent(country)}&user_id=${userId}&platform=copilot`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const resp = await response.json();
      if (resp.success) {
        setPlans(resp.data.subscription_plans);

      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };
  // Fetch plans when country and user data are available
  useEffect(() => {
    if (expertDetails?.profile?.country && (currentUser?.UserId || localStorage.getItem("profile"))) {
      fetchPlans();
    }
  }, [expertDetails?.profile?.country, currentUser?.UserId]);
  return (
    <div className="my-3 SettingsDashboard">
      <div className="ExpertSettingsDashboard--Header mb-3">
        <div className="d-flex justify-content-between" role="presentation">
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              onClick={() => {
                navigate("/clinical/settings?view=Edit Profile");
                setSelectedOption("Edit Profile");
              }}
              role="button"
              color="text.primary"
              sx={{
                fontWeight: "500",
                fontSize: "20px",
                textDecoration: "none",
              }}
              id="settings"
              className="settings d-flex text-secondary align-items-center justify-content-between gap-2 "
            >
              Settings
            </Link>

            <Typography
              sx={{ fontWeight: "500", fontSize: "20px" }}
              color="text.primary"
            >
              {selectedOption}
            </Typography>
          </Breadcrumbs>
          {/* <div onClick={() => setOpenQrModal(!openQrModal)} className="p-2  rounded" style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#EEEEEE", marginLeft: "10px", cursor: "pointer" }}>
            <QrCode />
          </div> */}
        </div>
      </div>

      <div style={{ overflowY: "auto" }} className=" ">
        <div
          // style={{ background: "#EEEEEE", width: isAusDomain() ? "384px" : "390px", }}
          style={{ background: "#EEEEEE", width:  plans?.some(plan => !plan?.disable_plan)?"280px" : "390px", }}

          className="d-flex flex-wrap mt-2 gap-1 p-1 rounded-pill"
        >
          <div
            style={{
              fontSize: "15px",

              fontWeight: 600,
              background: selectedOption === "Edit Profile" ? "white" : "",
              border: 0,
              color: selectedOption === "Edit Profile" ? "var(--Primary-color)" : "#898989",
            }}
            role="button"
            id="settings_edit_profile"
            className={`settings_edit_profile py-1 px-4 rounded-pill `}
            onClick={() => { handleOption("Edit Profile"); navigate("?view=Edit Profile") }}
          >
            Edit Profile
          </div>
          {/* <div
            style={{
              fontSize: "15px",

              fontWeight: 600,
              background: selectedOption === "Stella Mode" ? "white" : "",
              border: 0,
              color: selectedOption === "Stella Mode" ? "var(--Primary-color)" : "#898989",
            }}
            role="button"
            id="settings_stella_mode"
            className={`settings_stella_mode py-1  px-4 rounded-2 `}
            onClick={() => { handleOption("Stella Mode"); navigate("?view=Stella Mode") }}
          >
            Stella Mode
          </div> */}
          {/* {!isAusDomain() && <div
            style={{
              fontSize: "15px",

              fontWeight: 600,
              background: selectedOption === "Credits" ? "white" : "",
              border: 0,
              color: selectedOption === "Credits" ? "var(--Primary-color)" : "#898989",
            }}
            role="button"
            id="settings_credits"
            className={`settings_credits py-1 px-4 rounded-pill `}
            onClick={() => { handleOption("Credits"); navigate("?view=Credits") }}
          >
            Credits
          </div>} */}
          {plans?.some(plan => !plan?.disable_plan) && <div
            style={{
              fontSize: "15px",

              fontWeight: 600,
              background: selectedOption === "Plans & Billing" ? "white" : "",
              border: 0,
              color: selectedOption === "Plans & Billing" ? "var(--Primary-color)" : "#898989",
            }}
            role="button"
            id="settings_credits"
            className={`settings_credits py-1 px-4 rounded-pill `}
            onClick={() => { handleOption("Plans & Billing"); navigate("?view=Plans%20%26%20Billing") }}
          >
            Plans & Billing
          </div>}
          {/* {!isAusDomain() && <div
            style={{
              fontSize: "15px",

              fontWeight: 600,
              background: selectedOption === "Notes Template" ? "white" : "",
              border: 0,
              color: selectedOption === "Notes Template" ? "var(--Primary-color)" : "#898989",
            }}
            role="button"
            id="settings_note_template"
            className={`settings_note_template py-1 px-4 rounded-pill `}
            onClick={() => {
              handleOption("Notes Template");
              window.location.href = `https://myaccount${getSubDomain()}/onboarding/home/profession/select-template/?redirect=${window.location.origin}/auth&userType=repeat_user`
            }}
          >
            Notes Template
          </div>} */}

        </div>
      </div>


      <div className="ExpertSettingsDashboard--Content p-0 p-md-4">
        {/* <h4 className="d-flex gap-2 align-items-center">{selectedOption}
          {selectedOption === "Credits" && <Tooltip
            arrow
            title={
              <p className="m-0" style={{ fontSize: "14px", color: "white" }}>
                Your credit transaction history is listed here
              </p>
            }
            placement="top-start"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "common.black",
                  "& .MuiTooltip-arrow": {
                    color: "common.black",
                  },
                  color: "common.white",
                  padding: "10px",
                },
              },
            }}
          >
            <InfoOutlined sx={{ fontSize: "16px", color: "black" }} />
          </Tooltip>}</h4> */}
        {selectedOption === "Edit Profile" && (
          <EditClinicalProfile fetchData={postData} data={userData?.profile} clinicData={userData?.clinic} professionalData={userData?.professional} />
        )}
        {/* {selectedOption === "Stella Mode" && <StellaMode />} */}
        {selectedOption === "Plans & Billing" && <PlansBilling planslist={plans} />}
        {/* {selectedOption  === "Credits" && <Credits />} */}
        <MerchantQr open={openQrModal} close={() => setOpenQrModal(false)} />
      </div>
    </div>
  );
};

export default ExpertClinicalSettingsDB;
